var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infos-register"},[_c('form-default',{attrs:{"contentTitle":_vm.$t('views.InfosRegister.contentTitle'),"titleLogin":_vm.$t('views.InfosRegister.titleLogin'),"inputs":_vm.inputs,"button":_vm.button}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }